module.exports = __webpack_public_path__ + "static/media/checkmark__branded.74120b61.svg";